const SIGNUP_ERROR_MESSAGES: Record<string, string> = {
  'auth/email-already-in-use': 'An account with this email already exists. Please log in instead.',
  'auth/network-request-failed': 'Network error. Please check your connection and try again.',
  'auth/too-many-requests': 'Too many attempts. Please wait a moment and try again.',
  'auth/invalid-email': 'Please enter a valid email address.',
  'auth/weak-password': 'Password is too weak. Please use a stronger password.',
};

const TIMEOUT_KEYWORDS = ['timed out', 'timeout', 'taking longer'];

export const getSignupErrorMessage = (error: unknown): string => {
  if (!error) {
    return 'Something went wrong creating your account. Please try again.';
  }

  const errorObj = error as { code?: string; message?: string };

  // Check Firebase error codes
  if (errorObj.code && SIGNUP_ERROR_MESSAGES[errorObj.code]) {
    return SIGNUP_ERROR_MESSAGES[errorObj.code];
  }

  // Check for timeout-related messages
  const message = errorObj.message || String(error);
  if (TIMEOUT_KEYWORDS.some((keyword) => message.toLowerCase().includes(keyword))) {
    return 'Account setup is taking longer than expected or there was an error. Please refresh the page.';
  }

  // Return the original message if it's user-readable, otherwise a default
  if (errorObj.code) {
    return 'Something went wrong creating your account. Please try again.';
  }

  return message || 'Something went wrong creating your account. Please try again.';
};
